// import { configureStore } from "@reduxjs/toolkit";
// import rootReducer from "../RootReducer";

// const store = configureStore({
//   reducer: rootReducer,
// });

// export default store;
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./RootReducer";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import thunk from 'redux-thunk';
import storageSession from 'redux-persist/lib/storage/session'

const persistConfig = {
  key: "root",  
  storage: storageSession,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk]
});
// export const store;
export const persistor = persistStore(store);
